import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
// import { ThemeProvider } from "@mui/system";
// import theme from "./theme";

ReactDOM.render(
  <React.StrictMode>
        

        <BrowserRouter>
    
        <SnackbarProvider
          maxSnack={1}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          preventDuplicate
        >
          <App />
      </SnackbarProvider>
      </BrowserRouter>
      
   </React.StrictMode>,
   document.getElementById('root')
);